import instituteRequest from 'utils/instituteRequest'
import studentRequest from 'utils/studentRequest'
export const getEventsList = data => async (dispatch, getState) => {
  const category = data?.category && `&category=${data?.category}`
  const search = data?.search && `&search=${data?.search}`
  const sort = data?.sort && `&sort=${data?.sort}`
  const isCalender = data?.forCalendar
  const forRecentlyAdded = data?.forRecentlyAdded ? `&forRecentlyAdded=true&sort=createdAt&order=desc` : ''
  try {
    let response
    if (isCalender) {
      response = await instituteRequest.get(
        `institutes/instituteCampus/${data?.instituteCampusId}/student/${data?.studentId}/events?forCalendar=${data?.forCalendar}`
      )
    } else {
      response = await instituteRequest.get(
        `institutes/instituteCampus/${data?.instituteCampusId}/student/${data?.studentId}/events?pageLimit=${data?.pageLimit}&pageNo=${data?.pageNo}${search}${forRecentlyAdded}&forRegisterEvent=${data?.forRegisterEvent}${sort}&from=${data?.from}${category}&occurence=${data?.occurence}&forCalendar=${data?.forCalendar}`
      )
    }
    return response
  } catch (err) {
    //
  }
}

export const getEventDetailsById = (eventsId, studentId) => async () => {
  try {
    const response = await instituteRequest.get(
      `institutes/events/${eventsId}/student/${studentId}`
    )
    return response
  } catch (err) {
    //
  }
}

export const registerEvent = data => async () => {
  try {
    const response = await studentRequest.post(
      `students/events/instituteCampusId/${data?.instituteCampusId}/studentId/${data?.studentId}/registration`,
      data?.payLoad
    )
    return response
  } catch (err) {
    //
  }
}
